import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Avatar, Pagination } from "../../components"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { all } from "../../api/Note"

/* Helpers */
import { utils } from "../../helpers"

/* Constants */
import { env } from "../../constants"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"
import { NoteIcon, CloseIcon, SearchIcon, TableIcon, ClockIcon } from "./DashboardIcons"


/* PAGE SIZE — THE VERY SAME ONE THE CONTROLLER KEEPS */
const SIZE = 20

/* THE INNER SEARCH APPEARS ONLY WHEN THE LIST OF GAMES IS LONG ENOUGH TO SCROLL */
const SEARCHABLE = 6


/* Widget Dashboard Notes */
class Notes extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            status: "loading",

            /* Data */
            list: [],
            count: 0,
            games: [],
            stats: { total: 0, games: 0, last: null },

            /* Filter */
            page: 1,
            table: "",
            search: "",
        }
    }

    /* Open Action */
    open = () => {

        this.setState({
            visible: true,
            status: "loading",
            list: [],
            count: 0,
            games: [],
            stats: { total: 0, games: 0, last: null },
            page: 1,
            table: "",
            search: "",
        }, () => {
            this.load(1)
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Load Action — the token decides the scope, the chip only narrows it down */
    load = (page = 1) => {

        /* Fields */
        const { table, search } = this.state

        /* Set Page */
        this.setState({ page, status: "loading" })

        /* Send to REST API */
        all({ page, table, search }).then((response) => {
            if (response && response.status === 200) {
                this.setState({
                    status: "ok",
                    list: Array.isArray(response.data.list) ? response.data.list : [],
                    count: response.data.count ? response.data.count : 0,

                    /* The chips never depend on the chosen chip, so they are kept once they arrive */
                    games: Array.isArray(response.data.games) ? response.data.games : [],
                    stats: response.data.stats ? response.data.stats : { total: 0, games: 0, last: null },
                })
            }
            else {
                this.setState({ status: "error", list: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", list: [], count: 0 })
        })

    }

    /* Select A Game — the list always starts from the first page again */
    select = (table) => {
        this.setState({ table }, () => this.load(1))
    }

    /* Search Action — the form keeps Enter from reloading the page */
    submit = (event) => {
        event.preventDefault()
        this.load(1)
    }

    /* Clear The Search */
    clear = () => {
        this.setState({ search: "" }, () => this.load(1))
    }

    /* Draw The Head Of The Modal */
    _head = () => {

        /* Fields */
        const { stats } = this.state

        /* Time Of The Last Note */
        const last = stats.last ? utils.getTime(stats.last) : null

        return (
            <div className="dsh-notes--header">

                <div className="dsh-notes--header-icon">
                    <NoteIcon size={18} />
                </div>

                <div className="dsh-notes--header-text">

                    <h2>{t("dshNotes.title")}</h2>

                    <div className="dsh-notes--header-note">

                        <span>{t("dshNotes.subtitle")}</span>

                        {last &&
                            <div className="dsh-notes--header-last">
                                <ClockIcon size={12} />
                                {last.date}, {last.time}
                            </div>
                        }

                    </div>

                </div>

                <div onClick={() => this.close()} className="dsh-notes--close">
                    <CloseIcon />
                </div>

            </div>
        )
    }

    /* Draw The Games Of The Filter */
    _games = () => {

        /* Fields */
        const { games, table, search, stats } = this.state

        /* Check Games — a scope without a single note needs no filter at all */
        if (games.length === 0) {
            return null
        }

        return (
            <div className="dsh-notes--filter">

                <div className="dsh-notes--filter-head">

                    <div className="dsh-notes--filter-title">
                        <TableIcon />
                        {t("dshNotes.games")}
                        <span className="dsh-notes--counter">{games.length}</span>
                    </div>

                    {games.length > SEARCHABLE &&
                        <form onSubmit={this.submit} className="dsh-notes--search">
                            <SearchIcon size={14} />
                            <input
                                value={search}
                                onChange={(event) => this.setState({ search: event.target.value })}
                                placeholder={t("dshNotes.searchPlaceholder")}
                            />
                            {search !== "" &&
                                <div onClick={() => this.clear()} className="dsh-notes--search-clear">
                                    <CloseIcon size={11} />
                                </div>
                            }
                        </form>
                    }

                </div>

                <div className="dsh-notes--chips">

                    <div onClick={() => this.select("")} className={`dsh-notes--chip ${table === "" ? "active" : ""}`}>
                        {t("dshNotes.allGames")}
                        <span className="dsh-notes--chip-count">{stats.total}</span>
                    </div>

                    {games.map((item, index) =>
                        <div
                            onClick={() => this.select(String(item.id))}
                            className={`dsh-notes--chip ${String(table) === String(item.id) ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {utils.checkValue(item.name, utils.checkValue(item.slug, `#${item.id}`))}
                            <span className="dsh-notes--chip-count">{item.count}</span>
                        </div>
                    )}

                </div>

            </div>
        )
    }

    /* Draw One Note — the text comes first, the game and the round stay under it as meta */
    _note = (item, index) => {

        /* Fields */
        const datetime = utils.getTime(item.createdAt)

        return (
            <div className="dsh-notes--item" key={`${index}`}>

                <Avatar uri={item.adminImage ? `${env.mediapoint}${item.adminImage}` : null} size={36} />

                <div className="dsh-notes--item-body">

                    <div className="dsh-notes--item-head">

                        <div className="dsh-notes--item-name">{utils.checkValue(item.adminName, "—")}</div>

                        <div className="dsh-notes--item-time">
                            <ClockIcon size={11} />
                            {datetime.date}, {datetime.time}
                        </div>

                    </div>

                    <div className="dsh-notes--item-message">{item.message}</div>

                    <div className="dsh-notes--item-meta">

                        <div className="dsh-notes--tag dsh-notes--tag-game">
                            <TableIcon size={11} />
                            {utils.checkValue(item.tableName, utils.checkValue(item.tableSlug, "—"))}
                        </div>

                        {item.studioName &&
                            <div className="dsh-notes--tag">{item.studioName}</div>
                        }

                        {item.gameID &&
                            <div className="dsh-notes--tag dsh-notes--tag-round">#{item.gameID}</div>
                        }

                    </div>

                </div>

            </div>
        )
    }

    /* Draw The Body Of The Modal */
    _body = () => {

        /* Fields */
        const { status, list, count, page, search, table } = this.state

        /* Check Status */
        if (status === "loading") {
            return <div className="dsh-notes--loading"><LoadingOutlined /></div>
        }

        /* Check Error */
        if (status !== "ok") {
            return (
                <div className="dsh-notes--empty">
                    <NoteIcon size={34} />
                    <span>{status === "network" ? t("dshNotes.network") : t("swal.generic")}</span>
                </div>
            )
        }

        /* Check Data */
        if (list.length === 0) {

            /* A narrowed down list is empty because of the filter, an untouched one because there are no notes yet */
            const narrowed = search !== "" || table !== ""

            return (
                <div className="dsh-notes--empty">
                    <NoteIcon size={34} />
                    <span>{narrowed ? t("dshNotes.nothingFound") : t("dshNotes.empty")}</span>
                </div>
            )
        }

        return (
            <div className="dsh-notes--list">

                {list.map((item, index) => this._note(item, index))}

                <Pagination size={SIZE} page={page} total={count} onPageChange={(page) => this.load(page)} />

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="dsh-notes--modal"
                overlayClassName="dsh-notes--overlay"
                closeTimeoutMS={200}
            >

                {/* Draw Head */}
                {this._head()}

                {/* Draw Games */}
                {this._games()}

                {/* Draw Body */}
                {this._body()}

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Notes)
